/**
 * Glider domain type and the single hard-coded glider used until the
 * searchable picker over the full XCSoar database lands in GLI-138.
 *
 * The ASW-27 record below is copied verbatim from `src/data/gliders.json` (the
 * GLI-136 import). GLI-138 replaces this constant with the lazily-loaded
 * database; the type stays.
 */
import type { PolarCoeffs, ThreePoints } from "./polar";

export type Glider = {
  readonly id: string;
  readonly manufacturer: string;
  readonly model: string;
  readonly displayName: string;
  readonly wingArea_m2: number;
  readonly referenceMass_kg: number;
  readonly emptyMass_kg: number | null;
  readonly maxBallast_kg: number;
  readonly vNe_kmh: number | null;
  readonly polarPoints: ThreePoints;
  readonly polar: PolarCoeffs;
  readonly source: "xcsoar" | "user";
  readonly notes?: string;
};

export const ASW27: Glider = {
  id: "asw-27",
  manufacturer: "Schleicher",
  model: "ASW-27",
  displayName: "Schleicher ASW-27",
  wingArea_m2: 9,
  referenceMass_kg: 365,
  emptyMass_kg: 235,
  maxBallast_kg: 165,
  vNe_kmh: 114,
  polarPoints: [
    { v_kmh: 88.8335, w_ms: -0.5939 },
    { v_kmh: 130, w_ms: -0.8511 },
    { v_kmh: 170, w_ms: -1.6104 },
  ],
  polar: {
    a: 0.00015689602762120714,
    b: -0.02808630828636214,
    c: 1.8507772104286775,
  },
  source: "xcsoar",
  notes: "from idaflieg 1997 & 2018",
};
